import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  ApplicationConfig,
  Injector,
  inject,
  importProvidersFrom,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { provideNgxMask } from 'ngx-mask';
import { AppInjector } from '@shared/config/app-injector';
import { ThemeState } from '@shared/states/theme.state';
import { APP_ROUTES } from './app.routes';
import { initTheme } from './initializers/theme.initialiser';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(APP_ROUTES),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    importProvidersFrom(StoreModule.forRoot({}), EffectsModule.forRoot([])),
    provideNgxMask(),
    provideAppInitializer(() => {
      AppInjector.Injector = inject(Injector);
    }),
    provideAppInitializer(() => {
      const initializerFn = initTheme(inject(ThemeState));
      return initializerFn();
    }),
  ],
};
